module.exports = __webpack_public_path__ + "static/media/Flik8.3f27ff74.pdf";